var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page login"},[_c('img',{staticClass:"logo",attrs:{"src":"logo.png","alt":""}}),_c('div',{staticClass:"tips"},[_vm._v("未找到商家")])])
}]

export { render, staticRenderFns }